<div
  [class]="`tt-customisable-flowchart-element-icon tt-customisable-flowchart-element-icon-${flowchartNodeConfig().type}`"
  [ttMenuTriggerFor]="menu">
  {{ flowchartNodeConfig().content ?? '&nbsp;' }}
</div>

<tt-menu #menu>
  @for (preset of menuColorPresets(); track preset.id) {
    <tt-color-preset-card
      class="tt-color-preset-menu-item"
      [class.tt-color-preset-menu-item--selected]="flowchartNodeConfig().colorPreset?.id === preset.id"
      [colorPreset]="preset"
      [readonly]="true"
      (click)="colorPresetChanged.emit(preset.id)" />
  }

  @if (menuColorPresets().length === 0) {
    <div class="tt-flowchart-customisations-settings-tab_accordion-empty">
      {{ 'SettingsPage.OrganisationSettingsTab.FlowchartCustomisations.NoColorPresets' | transloco }}
    </div>
  } @else {
    <div
      class="tt-color-preset-menu-item"
      [class.tt-color-preset-menu-item--selected]="!flowchartNodeConfig().colorPreset?.id"
      (click)="colorPresetChanged.emit(undefined)">
      {{ 'Default' | transloco }}
    </div>
  }
</tt-menu>
